// actions/connect/chat.js

import { attachAuth } from '../../utils/authService';
import PubSub         from 'pubsub-js';

// --- ALL ---

export function connectChatHasErrored(bool) {
  return {
    type: 'CONNECT_CHAT_HAS_ERRORED',
    hasErrored: bool
  };
}

export function connectChatIsLoading(bool) {
  return {
    type: 'CONNECT_CHAT_IS_LOADING',
    isLoading: bool
  };
}

export function connectChatFetchDataSuccess(obj) {
  return {
    type: 'CONNECT_CHAT_FETCH_DATA_SUCCESS',
    obj
  };
}

export function connectChatFetchData(host, instanceId, flowId, userName, attributes) {
  return (dispatch) => {
    dispatch(connectChatIsLoading(true));
    dispatch(connectChatHasErrored(false));
    fetch(host + 'connect/chat', {
      method: 'post',
      body: JSON.stringify({ ContactFlowId: flowId, InstanceId: instanceId, Username: userName, Attributes: attributes }),
      headers: attachAuth()
    }).then(promise => {
        if (!promise.ok) {
          throw Error(promise.statusText);
        }
        
        promise.json()
          .then(result => {
            dispatch(connectChatFetchDataSuccess(result));
            dispatch(connectChatHasErrored(false));
            dispatch(connectChatIsLoading(false));
            PubSub.publish('connect.chat.response', result);
          })
          .catch((ex) => {
            console.log(ex);
            dispatch(connectChatHasErrored(true));
            dispatch(connectChatIsLoading(false));
            PubSub.publish('connect.chat.error');
          });
    })
    .catch((ex) => {
      console.log(ex);
      dispatch(connectChatHasErrored(true));
      dispatch(connectChatIsLoading(false));
      PubSub.publish('connect.chat.error');
    });
  };
}